import React from 'react';
import { Section } from './ui/Section';
import { WindIcon, UserIcon, BrainIcon, LampIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  const phases = [{
    icon: WindIcon,
    title: '1. Desacelerar (Respiración)',
    desc: 'Una señal de 2–4 minutos que indica seguridad a tu sistema nervioso de inmediato.'
  }, {
    icon: UserIcon,
    title: '2. Drenar (Cuerpo)',
    desc: 'Una liberación de tensión de 7 minutos enfocada en la mandíbula, cuello, pecho y caderas.'
  }, {
    icon: BrainIcon,
    title: '3. Decodificar (Mente)',
    desc: "Un 'contenedor' estructurado para los pensamientos acelerados (no se requiere pensamiento positivo)."
  }, {
    icon: LampIcon,
    title: '4. Atenuar (Entorno)',
    desc: 'Cambios simples que reentrenan tu dormitorio como un poderoso disparador de sueño.'
  }];
  return <Section className="bg-navy-900" dark={true} data-id="element-162">
      <div className="text-center mb-16" data-id="element-163">
        <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-164">
          El problema no eres tú.{' '}
          <span className="text-gold-400 italic" data-id="element-165">Es el orden.</span>
        </h2>
        <p className="text-xl text-cream-100/70 max-w-2xl mx-auto" data-id="element-166">
          La mayoría de las personas intentan arreglar el sueño después de que
          la ansiedad ya tomó el control. El Ciclo de Serenidad funciona porque
          comienza antes de que empiece la espiral.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-167">
        {phases.map((phase, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-navy-800 p-8 rounded-2xl border border-navy-700 hover:border-gold-500/30 transition-colors duration-300" data-id="element-168">
            <div className="w-12 h-12 bg-navy-900 rounded-full flex items-center justify-center mb-6 border border-navy-700 shadow-inner" data-id="element-169">
              <phase.icon className="w-6 h-6 text-gold-400" data-id="element-170" />
            </div>
            <h3 className="text-xl font-serif text-cream-50 mb-3" data-id="element-171">
              {phase.title}
            </h3>
            <p className="text-cream-100/70 leading-relaxed" data-id="element-172">{phase.desc}</p>
          </motion.div>)}
      </div>

      <div className="mt-16 text-center" data-id="element-173">
        <p className="text-2xl font-serif italic text-gold-400" data-id="element-174">
          No es largo. No es complicado. Es repetible.
        </p>
      </div>
    </Section>;
}